import axios from "axios";
import Enviornment from "../utils/Enviornment";
import _ from "lodash";
import { getAuthToken } from "../selectors/auth";
import { retrieveToken } from "../utils/StorageManager";
import constants from "../constants";

let axiosInstance = null;


function createInstance(headerOptions,returnType) {
  const instance = axios.create({
    baseURL: Enviornment.API_DOMAIN,
    timeout: 30000 /** HttpTimeout:30sec **/,
    headers: {

      "Content-Type": "application/json",
    ...headerOptions
    },
    withCredentials: true,
    withXSRFToken: true,
    ...returnType
  });

  instance.interceptors.request.use(async (config) => {
    const token = await retrieveToken(constants.AUTH_TOKEN);
    if(!_.isEmpty(token)) {
      config.headers["Authorization"] =`Bearer ${token}`;
    }

    return config;
  });

  instance.interceptors.response.use(
    (config) => config,
    (error) => {
      if (error.code === "ECONNABORTED" || _.get(error, ["response", "status"], "") === 408) {
        // Toast.error(I18n.t("general.errorMsg.networkTimeoutError"));
      }
      return Promise.reject(error);
    },
  );

  return instance;
}

if (!axiosInstance) {
  axiosInstance = createInstance();
}

export const apiInstance = (headerOptions,returnType) => createInstance(headerOptions,returnType);
